import React from "react";
import Icon from "./Icon";
import { formatTime, sessionDateParts, sessionState } from "./classesModel";
import { sessionSeqLabel } from "../../courseHub/sessionsList/sessionsModel";

const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

function StateLine({ state, isNext, number }) {
  return (
    <span className="s">
      <span className="mono">{sessionSeqLabel(number)}</span>
      {state === "live" && <span className="lv"><span className="pulse" aria-hidden="true" />Live now</span>}
      {state === "held" && <span className="ok"><Icon n="check" s={13} w={2.6} />Held</span>}
      {state === "upcoming" && (isNext ? <span className="nx">Next session</span> : <span>Scheduled</span>)}
    </span>
  );
}

function Attendance({ state, checkedIn, enrolled }) {
  if (state === "upcoming") return <span className="am na">{plural(enrolled, "student")} expected</span>;
  const pct = enrolled > 0 ? Math.round((checkedIn / enrolled) * 100) : 0;
  return (
    <span className="am">
      <span className="top">
        <span><b>{checkedIn}</b> / {enrolled} {state === "live" ? "signed in" : "attended"}</span>
        <em>{pct}%</em>
      </span>
      <span className="bar"><i style={{ width: `${checkedIn > 0 ? Math.max(pct, 2) : 0}%` }} /></span>
    </span>
  );
}

/** Chronological session list for one class: date, time and state, attendance, and the next step for each session. */
export default function SessionTimeline({ title, sessions, next, enrolled, now, onTakeAttendance, onViewAttendance, onSessionDetails }) {
  return (
    <ol className="tl" aria-label={`Sessions for ${title}`}>
      {sessions.map((session, index) => {
        const state = sessionState(session, now);
        const parts = sessionDateParts(session);
        const isNext = next?.id === session.id;
        const total = session.totalStudents ?? enrolled;
        return (
          <li key={session.id ?? index} className={state === "held" ? "held" : state === "live" ? "live" : isNext ? "next" : ""}>
            <span className="dot" aria-hidden="true" />
            <span className="d"><small>{parts?.weekday ?? ""}</small><b>{parts ? `${parts.month} ${parts.day}` : "—"}</b></span>
            <span className="inf">
              {(session.startTime || session.endTime) && <span className="t">{formatTime(session.startTime)} – {formatTime(session.endTime)}</span>}
              <StateLine state={state} isNext={isNext} number={session.sessionNumber ?? index + 1} />
            </span>
            <Attendance state={state} checkedIn={session.checkedIn ?? 0} enrolled={total} />
            <span className="ra">
              {state === "live" && (
                <button type="button" className="btn btn-p btn-sm" onClick={() => onTakeAttendance(session)}>
                  <Icon n="check" s={13} w={2.6} />Take attendance
                </button>
              )}
              {state === "held" && <button type="button" className="btn btn-o btn-sm" onClick={() => onViewAttendance(session)}>View attendance</button>}
              {state === "upcoming" && <button type="button" className="btn btn-o btn-sm" onClick={() => onSessionDetails(session)}>Session details</button>}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
